import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/data/mock";
import { FadeUp } from "@/components/shared/RevealText";

export default function FAQSection() {
    return (
        <section className="relative border-t border-ink/10 bg-white py-24 md:py-32" data-testid="faq-section">
            <div className="container-x">
                <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
                    <FadeUp className="md:col-span-5">
                        <div className="eyebrow mb-4">Ch. 09 · FAQ</div>
                        <h2 className="h-display font-display text-[40px] font-black leading-[0.95] text-ink md:text-[60px]">
                            Questions,
                            <br />
                            <span className="serif-italic text-pink">answered</span>.
                        </h2>
                        <p className="mt-6 max-w-sm text-[15px] leading-relaxed text-slate-600 md:text-[16px]">
                            Everything you need to know about using the platform. Can&apos;t find your question? Head
                            to the contact page.
                        </p>
                    </FadeUp>
                    <FadeUp delay={0.1} className="md:col-span-7">
                        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
                            {FAQS.map((f, i) => (
                                <AccordionItem key={i} value={`item-${i}`} className="border-b border-ink/10">
                                    <AccordionTrigger className="py-6 text-left font-display text-[18px] font-semibold text-ink hover:no-underline md:text-[20px]" data-testid={`faq-trigger-${i}`}>
                                        <div className="flex items-start gap-5">
                                            <span className="text-[12px] font-semibold uppercase tracking-[0.24em] text-slate-400">
                                                0{i + 1}
                                            </span>
                                            <span>{f.q}</span>
                                        </div>
                                    </AccordionTrigger>
                                    <AccordionContent className="pb-8 pl-11 text-[15px] leading-relaxed text-slate-600 md:text-[16px]">
                                        {f.a}
                                    </AccordionContent>
                                </AccordionItem>
                            ))}
                        </Accordion>
                    </FadeUp>
                </div>
            </div>
        </section>
    );
}
